import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function RSIPage() {


  return (
    <ProjectLayout
      title="Road Smart Interactive (2025)"
      role="Unity Developer (C#) - VR / iOS"
      team="2"
      duration="6 Months"
      engine="Unity (C#), XCode, Testflight"
      about="Road Smart Interactive"
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/rsiVR2.mp4`}
      playLink={"https://www.roadsafetyeducation.vic.gov.au/educational-resources/programs/roadsmart-interactive"}
      playText="Road Smart Interactive Victoria Page"
      galleryImages = {[
      `${process.env.PUBLIC_URL}/img/rsi/3.png`,
    `${process.env.PUBLIC_URL}/img/rsi/1.png`,
    `${process.env.PUBLIC_URL}/img/rsi/2.jpg`,
    `${process.env.PUBLIC_URL}/img/rsi/4.png`,
  ]}
    >
      <section>
        <h2>About</h2>
        <p>
          Road Smart Interactive is an installation designed for high school students in Victoria and Western Australia. It is comprised of a 30-iPad networked experience and 2 VR experiences, with the aim of educating students about road safety in an immersive and engaging manner.
        </p>
      </section>

      <section>
        <h2>Skills Learned</h2>
        <p>
          This application taught me a lot about the logistics of networking such a large amount of iPads, debugging iOS apps at scale, and the challenges of physically installing an iPad experience.
        </p>
      </section>

    </ProjectLayout>
  );
}
